import { Link } from "react-router-dom";

/**
 * Shared header + footer chrome for the public docs pages (`/privacy`,
 * `/terms`, `/getting-started`). Matches the visual language of the
 * Landing page but adds explicit Docs / Privacy / Terms links in the
 * footer — required by the connector directory submissions.
 */
export function DocsHeader() {
  return (
    <header className="border-b border-zinc-200 dark:border-zinc-800">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 font-semibold tracking-tight text-lg"
        >
          <img
            src="/coauthor-mark.svg"
            alt=""
            className="w-6 h-6"
            aria-hidden="true"
          />
          Coauthor
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link
            to="/getting-started"
            className="text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100"
          >
            Getting started
          </Link>
          <Link
            to="/login"
            className="rounded-md bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900 px-3 py-1.5 text-sm font-medium hover:opacity-90"
          >
            Sign in
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function DocsFooter() {
  return (
    <footer className="mt-auto border-t border-zinc-200 dark:border-zinc-800">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-500">
        <span>Coauthor · built on the Skarp stack</span>
        <div className="flex items-center gap-4">
          <Link
            to="/privacy"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
          >
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-zinc-900 dark:hover:text-zinc-100">
            Terms
          </Link>
          <Link
            to="/getting-started"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
          >
            Docs
          </Link>
          <a
            href="https://skarp.app"
            className="hover:text-zinc-900 dark:hover:text-zinc-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            skarp.app
          </a>
        </div>
      </div>
    </footer>
  );
}
